var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#4BA55E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2545 24.2797C15.0426 24.4867 14.7426 24.6592 14.4778 24.6592C14.213 24.6592 13.913 24.4781 13.6923 24.2711L8.75 19.4416L10.321 17.9065L14.4866 21.9771L25.501 11.1365L27.0455 12.6975L15.2545 24.2797Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastTick);
export default __webpack_public_path__ + "static/media/toastTick.74546b9de8e0f0dd4864c9d45e43c3d0.svg";
export { ForwardRef as ReactComponent };